// extracted by mini-css-extract-plugin
module.exports = {"details":"details-3wUMf","info":"info-1h_vh","info__item":"info__item-2pbta","order":"order-2CSU8","order__prefix":"order__prefix-3HDfW","order__button":"order__button-3OCNM"};